import { me } from "@api/courses/reviewStats/users/me/api";

export const users = {
  me,
};
